export default "__VITE_ASSET__3964a513__"